// Copyright (c) 2022 by Move Closer

import isPlainObject from 'lodash/isPlainObject'

import { CanBeAlignedInGrid } from '../contracts'

/**
 * Checks if the passed-in object correctly implements the `CanBeAlignedInGrid.alignment` interface.
 *
 * @typeGuard
 * TODO: Consider simplification.
 */
// eslint-disable-next-line  @typescript-eslint/no-explicit-any
export const isAlignment = (subject: any): subject is CanBeAlignedInGrid['alignment'] => {
  if (!isPlainObject(subject)) {
    return false
  }

  if ('x' in subject) {
    if (!isPlainObject(subject.x)) {
      return false
    }

    // if ('desktop' in subject.x && !isValidEnumValue(subject.x.desktop, HorizontalAlignment)) {
    //   return false
    // }
    //
    // if ('mobile' in subject.x && !isValidEnumValue(subject.x.mobile, HorizontalAlignment)) {
    //   return false
    // }
  }

  if ('y' in subject) {
    if (!isPlainObject(subject.y)) {
      return false
    }

    // if ('desktop' in subject.y && !isValidEnumValue(subject.y.desktop, VerticalAlignment)) {
    //   return false
    // }
    //
    // if ('mobile' in subject.y && !isValidEnumValue(subject.y.mobile, VerticalAlignment)) {
    //   return false
    // }
  }

  return true
}
